
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/opt/atlassian/pipelines/agent/build/clients/main/sentry.client.config.ts")
            }
          });